module.exports = __webpack_public_path__ + "static/media/google.b5b62e04.svg";